import { render, staticRenderFns } from "./charts.vue?vue&type=template&id=5741f44a&scoped=true&"
import script from "./charts.vue?vue&type=script&lang=js&"
export * from "./charts.vue?vue&type=script&lang=js&"
import style0 from "./charts.vue?vue&type=style&index=0&id=5741f44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5741f44a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5741f44a')) {
      api.createRecord('5741f44a', component.options)
    } else {
      api.reload('5741f44a', component.options)
    }
    module.hot.accept("./charts.vue?vue&type=template&id=5741f44a&scoped=true&", function () {
      api.rerender('5741f44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chronic/components/charts.vue"
export default component.exports